import React from 'react';
import Image from 'next/image';

import { Title } from '../../typography/title';
import { Paragraph } from '../../typography/paragraph';
import { ButtonPrimary, ButtonSecondary } from '../../atoms/Button';

type CTASectionProps = {
  heading: string;
  subheading?: string;
  ctaText?: string;
  href?: string;
  imgSrc?: string;
  secondaryHref?: string;
  secondaryCtaText?: string;
  onCtaClick?: () => void;
  onSecondaryCtaClick?: () => void;
};

export default function CTASection({
  heading,
  subheading,
  ctaText = 'Learn More',
  href,
  imgSrc,
  secondaryHref,
  secondaryCtaText,
  onCtaClick,
  onSecondaryCtaClick,
}: CTASectionProps) {
  return (
    <div className="max-height-[324px] mx-auto flex max-w-7xl flex-col gap-10 px-8 lg:flex-row lg:items-center">
      <div>
        <div className="mb-6">
          <Title size="large">{heading}</Title>
        </div>
        {!!subheading && (
          <Paragraph size="large" color="neutral-600" className="whitespace-pre-line">
            {subheading}
          </Paragraph>
        )}
        <div className="mt-10 flex gap-6">
          {!!href && !!ctaText && (
            <ButtonPrimary href={href} onClick={onCtaClick}>
              {ctaText}
            </ButtonPrimary>
          )}
          {!!secondaryHref && !!secondaryCtaText && (
            <ButtonSecondary href={secondaryHref} onClick={onSecondaryCtaClick}>
              {secondaryCtaText}
            </ButtonSecondary>
          )}
        </div>
      </div>
      {!!imgSrc && (
        <div className="relative w-full max-w-[600px]">
          <Image alt="CTA section image" src={imgSrc} width={600} height={600} className="aspect-square w-full" />
        </div>
      )}
    </div>
  );
}
